import Vue from "vue";
import { mapState, mapGetters } from "vuex";
var mixin = {
  computed: {
    ...mapState({
      user: state => state.auth.user,
      basketProducts: state => state.product.basketProducts
    }),
    ...mapGetters({
      totalBasketItems: "product/totalBasketItems",
      basketTotal: "product/basketTotal"
    })
  },
  mounted() {
    if (this.user) {
      Vue.prototype.$mixpanel.register({
        user_id: this.user.uid,
        email: this.user.uemail
      });
    }
  },
  methods: {
    evtProductClicked(product) {
      window.fbq("track", "productClick", {
        content_name: product.name,
        content_ids: [product.id],
        content_type: "product",
        price: product.amount,
        content_category:
          product.subCategories.length > 0
            ? product.subCategories[0].category.name
            : "none",
        variant: product.colour,
        currence: "EUR"
      });
      // Vue.prototype.$mixpanel.track("productClick", {
      //   productName: product.name,
      //   productId: product.id,
      //   productPrice: product.amount,
      //   productSupplier: product.supplier.name,
      //   productCategory: product.subCategories[0].category.name,
      //   variant: product.colour
      // });
      if (window.dataLayer) {
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
        window.dataLayer.push({
          event: "productClick",
          ecommerce: {
            click: {
              actionField: { list: "Search Results" }, // Optional list property.
              products: [
                // {
                //   name: product.name, // Name or ID is required.
                //   id: product.id,
                //   price: product.amount,
                //   brand: product.brand.name,
                //   category:
                //     product.subCategories.length > 0
                //       ? product.subCategories[0].category.name
                //       : "none",
                //   variant: product.colour
                // }
                product
              ]
            }
          }
        });
      }
    },
    evtProductDetail(product) {
      window.fbq("track", "evtProductDetail", {
        name: product.name, // Name or ID is required.
        id: product.id,
        price: product.amount,
        brand: product.brand.name,
        category:
          product.subCategories.length > 0
            ? product.subCategories[0].category.name
            : "none",
        variant: product.colour
      });
      Vue.prototype.$mixpanel.track("viewProduct", {
        productName: product.name,
        productId: product.id,
        productPrice: product.amount,
        productSupplier: product.supplier.name,
        productCategory:
          product.subCategories.length > 0
            ? product.subCategories[0].category.name
            : "none"
      });
      // Vue.prototype.$mixpanel.track("viewProduct", {
      //   name: product.name, // Name or ID is required.
      //   id: product.id,
      //   price: product.amount,
      //   brand: product.brand.name,
      //   category: product.subCategories.length>0?product.subCategories[0].category.name:'none',
      //   variant: product.colour
      // });
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        ecommerce: {
          detail: {
            actionField: { list: "Apparel Gallery" }, // 'detail' actions have an optional list property.
            products: [
              {
                name: product.name, // Name or ID is required.
                id: product.id,
                price: product.amount,
                brand: product.brand.name,
                category:
                  product.subCategories.length > 0
                    ? product.subCategories[0].category.name
                    : "none",
                variant: product.colour
              }
            ]
          }
        }
      });
    },
    evtPushProductToCart(product, quantity = null) {
      window.fbq("track", "AddToCart", {
        content_name: product.name,
        content_ids: [product.id],
        content_type: "product",
        contents: {
          id: product.id,
          quantity: quantity !== null ? quantity : 1
        },
        price: product.amount,
        content_category:
          product.subCategories.length > 0
            ? product.subCategories[0].category.name
            : "none",
        variant: product.colour,
        quantity: quantity !== null ? quantity : 1,
        currence: "EUR"
      });
      Vue.prototype.$mixpanel.track("addToCart", {
        productName: product.name,
        productId: product.id,
        productPrice: product.amount,
        productSupplier: product.supplier.name,
        productCategory:
          product.subCategories.length > 0
            ? product.subCategories[0].category.name
            : "none"
      });
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: "EUR",
          add: {
            // 'add' actionFieldObject measures.
            products: [
              {
                //  adding a product to a shopping cart.
                name: product.name,
                id: product.id,
                price: product.amount,
                brand: product.brand.name,
                category:
                  product.subCategories.length > 0
                    ? product.subCategories[0].category.name
                    : "none",
                variant: product.colour,
                quantity: quantity !== null ? quantity : 1
              }
            ]
          }
        }
      });
    },
    evtPopProductFromCart(product, quantity = null) {
      window.fbq("track", "popFromCart", {
        content_name: product.name,
        content_ids: [product.id],
        content_type: "product",
        contents: {
          id: product.id,
          quantity: quantity !== null ? quantity : 1
        },
        price: product.amount,
        content_category:
          product.subCategories.length > 0
            ? product.subCategories[0].category.name
            : "none",
        variant: product.colour,
        quantity: quantity !== null ? quantity : 1,
        currence: "EUR"
      });
      Vue.prototype.$mixpanel.track("popFromCart", {
        productName: product.name,
        productId: product.id,
        productPrice: product.amount,
        productSupplier: product.supplier.name,
        productCategory:
          product.subCategories.length > 0
            ? product.subCategories[0].category.name
            : "none"
      });
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
      window.dataLayer.push({
        event: "removeFromCart",
        ecommerce: {
          remove: {
            // 'remove' actionFieldObject measures.
            products: [
              {
                //  removing a product to a shopping cart.
                name: product.name,
                id: product.id,
                price: product.amount,
                brand: product.brand.name,
                category:
                  product.subCategories.length > 0
                    ? product.subCategories[0].category.name
                    : "none",
                variant: product.colour,
                quantity: product.quantity !== null ? quantity : 1
              }
            ]
          }
        }
      });
    },
    evtCheckout() {
      Vue.prototype.$mixpanel.track("checkout", {
        productIds: this.basketProducts.map(a => a.id),
        basketTotal: this.basketTotal,
        basketTotalItems: this.totalBasketItems
      });
    },
    evtOrderComplete() {
      Vue.prototype.$mixpanel.track("CompleteOrder", {
        productIds: this.basketProducts.map(a => a.id),
        totalPrice: this.basketTotal,
        productCount: this.totalBasketItems
      });
    },
    evtLogin() {
      Vue.prototype.$mixpanel.track("login", {
        email: this.user.uemail
      });
    },
    evtLogout() {
      Vue.prototype.$mixpanel.track("logout", {
        email: this.user.uemail
      });
    },
    evtSelectCategory(category) {
      Vue.prototype.$mixpanel.track("selectCategory", {
        category: category
      });
    },
    evtSearchCatalogue() {
      Vue.prototype.$mixpanel.track("searchCatalogue");
    },
    evtCatalogueItemSelected(product) {
      if (product.subCategories.length > 0) {
        Vue.prototype.$mixpanel.track("catalogueItemSelected", {
          productName: product.name,
          productId: product.id,
          productPrice: product.amount,
          productSupplier: product.supplier.name,
          productCategory:
            product.subCategories.length > 0
              ? product.subCategories[0].category.name
              : "none"
        });
      }
    }
  }
};
export default mixin;
